import { sendEvent } from "~/app/analytics/ga/ga";

export const trackUserSeesRecommendedProductSection = (designation: string) => {
  sendEvent({
    event: "recommended_product_interaction",
    push_context: "recommended_product_section_seen",
    product_name: designation,
  } as any);
};

export const trackUserOpensRecommendedProductSection = (designation: string, opened: boolean) => {
  sendEvent({
    event: "recommended_product_interaction",
    push_context: `recommended_product_section_${opened ? "opened" : "closed"}`,
    product_name: designation,
  } as any);
};

export const trackUserClickRecommendedProductSectionDetails = (designation: string) => {
  sendEvent({
    event: "recommended_product_interaction",
    push_context: `recommended_product_details_seen`,
    product_name: designation,
  } as any);
};

export const trackUserAddRecommendedProductToCart = (designation: string, quantity: number) => {
  sendEvent({
    event: "recommended_product_interaction",
    push_context: `recommended_product_added_to_cart`,
    quantity: quantity,
    product_name: designation,
  } as any);
};

export const trackUserAddRecommendedProductPurchased = (designation: string, quantity: number) => {
  sendEvent({
    event: "recommended_product_interaction",
    push_context: `recommended_product_purchased`,
    quantity: quantity,
    product_name: designation,
  } as any);
};

export const trackUserAddRecommendedProductToWishlist = (designation: string) => {
  sendEvent({
    event: "recommended_product_interaction",
    push_context: `recommended_product_added_to_wishlist`,
    product_name: designation,
  } as any);
};
